import { render, staticRenderFns } from "./receiverAddress.vue?vue&type=template&id=1c0b1fbb&scoped=true&"
import script from "./receiverAddress.vue?vue&type=script&lang=ts&"
export * from "./receiverAddress.vue?vue&type=script&lang=ts&"
import style0 from "./receiverAddress.vue?vue&type=style&index=0&id=1c0b1fbb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0b1fbb",
  null
  
)

export default component.exports